/**
 * BreadcrumbJsonLd — the BreadcrumbList <script> for a page, from the SAME
 * trail object the visible <Breadcrumb> renders (FRIDGE-269, Phase 1).
 *
 * Emits nothing for a trail shorter than two levels: a one-item
 * BreadcrumbList (the home page's old "Fridge.com" list) is noise. Regular
 * <script> (not next/script) so the JSON-LD is in the server-rendered HTML
 * for crawlers; also safe inside a client component (the tool shell) — the
 * markup is identical on the server and after hydration.
 */

import { buildBreadcrumbSchema } from '@/lib/structured-data'
import { isRenderableTrail, type BreadcrumbTrail } from '@/lib/breadcrumbs'
import { JsonLdScript } from './json-ld-script'

export function BreadcrumbJsonLd({
  trail,
  id = 'breadcrumb-schema',
}: {
  trail: BreadcrumbTrail | null | undefined
  id?: string
}) {
  if (!isRenderableTrail(trail)) return null
  return <JsonLdScript id={id} data={buildBreadcrumbSchema(trail)} />
}
